import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8ec72f84")

_pushScopeId("data-v-8ec72f84")
const _hoisted_1 = { class: "mb-4 flex justify-between items-baseline" }
const _hoisted_2 = { class: "flex items-baseline" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "confirmed-shift mr-1" }, null, -1)
const _hoisted_4 = { class: "overflow-auto" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "flex items-center w-40" }
const _hoisted_7 = { class: "relative h-full -m-1" }
const _hoisted_8 = { class: "text-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_DatePicker, {
        width: "140",
        format: _ctx.DATE_FORMAT,
        modelValue: _ctx.date,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.date = $event)),
        "is-show-next-date": ""
      }, null, 8, ["format", "modelValue"]),
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", null, _toDisplayString(_ctx.t('shiftRegistration.confirmedShift')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Table, {
        headers: _ctx.shiftRegisterDataHeader,
        data: _ctx.shiftRegisterData
      }, {
        director: _withId(({ item }) => [
          _createVNode("div", _hoisted_5, _toDisplayString(item.director), 1)
        ]),
        name: _withId(({ item }) => [
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_Avatar, {
              width: "40px",
              height: "40px",
              src: item.avatar,
              class: "mr-2"
            }, null, 8, ["src"]),
            _createVNode("div", null, _toDisplayString(item.name), 1)
          ])
        ]),
        target_time: _withId(({ item }) => [
          _createTextVNode(_toDisplayString(_ctx.displayTargetTime(item)), 1)
        ]),
        "9AM": _withId(({ item }) => [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", {
              class: "time-line h-full",
              style: _ctx.styleTimeLine(item)
            }, null, 4)
          ])
        ]),
        time_total: _withId(({ item }) => [
          _createVNode("div", _hoisted_8, _toDisplayString(_ctx.displayTimeTotal(item)), 1)
        ]),
        _: 1
      }, 8, ["headers", "data"])
    ])
  ]))
})